import Header from '@components/Header';
import Loading from '@components/Loading';
import { PaymentErrorType } from '@models/error';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';

import useUserCancel from './hooks/useUserCancel';

interface Params {
    type: PaymentErrorType;
    payload: string;
}

const UserPaymentCancelActivity: ActivityComponentType<Params> = ({ params }:{params: Params}) => {
  useUserCancel(params);
  return (
      <AppScreen>
          <Header title='사용자 결제 취소' />
          <Loading/>
      </AppScreen>
  );
};

export default UserPaymentCancelActivity;
